import {
  Checkbox as MaterialCheckbox,
  FormControlLabel
} from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import {
  TooltipArrowLeft,
  TooltipArrowUp
} from "@saleor/coupons/components/CouponDetails/Tooltip";
import React, { ChangeEvent, FC, useCallback } from "react";

import { useStyles } from "./styles";

interface ICheckboxProps {
  isChecked: boolean;
  onChange: (val: boolean) => void;
  labelText: string;
  infoTooltipText: string;
  isDisabled: boolean;
  tooltipPlacement?: "top" | "right";
}

const Checkbox: FC<ICheckboxProps> = ({
  isChecked,
  onChange,
  labelText,
  infoTooltipText,
  isDisabled,
  tooltipPlacement = "top"
}) => {
  const classes = useStyles({});
  const TooltipComponent =
    tooltipPlacement === "right" ? TooltipArrowLeft : TooltipArrowUp;
  const tooltipAnchorPlacement =
    tooltipPlacement === "right" ? "right" : "bottom";

  const onCheckboxValueChange = useCallback(
    (_e: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onChange(checked);
    },
    [onChange]
  );

  return (
    <div>
      <FormControlLabel
        control={
          <MaterialCheckbox
            checked={isChecked}
            onChange={onCheckboxValueChange}
          />
        }
        label={
          <div className={classes.labelContainer}>
            {labelText}
            <TooltipComponent
              title={infoTooltipText}
              placement={tooltipAnchorPlacement}
            >
              <InfoOutlined color="primary" />
            </TooltipComponent>
          </div>
        }
        labelPlacement="end"
        disabled={isDisabled}
      />
    </div>
  );
};

export default Checkbox;
